<template>
  <card>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <h2>用戶權限</h2>
        </div>
      </div>
    </div>
    <div class="container">
      <div style="margin: 10px 10px 10px 10px;">
        <el-row>
          <el-col :span="6">
            <el-input placeholder="Search" v-model="filters[0].value"></el-input>
          </el-col>
        </el-row>
      </div>

      <data-tables
        :data="tableData"
        :pagination-props="{ pageSizes: [10, 15, 20] }"
        :filters="filters"
        :table-props="tableProps"
      >
        <el-table-column label="用戶名稱" prop="name" sortable="custom" min-width="20px">
          <template slot-scope="scope">{{scope.row.name}}</template>
        </el-table-column>
        <el-table-column label="電話" prop="phone" sortable="custom" min-width="30px">
          <template slot-scope="scope">{{scope.row.phone}}</template>
        </el-table-column>

        <el-table-column label="管理權限" min-width="20px">
          <template slot-scope="scope">
            <p v-for="acl in scope.row.acls" :key="scope.row.name+acl">{{aclTranslator(acl)}}</p>
          </template>
        </el-table-column>
        <el-table-column label="#" min-width="20px">
          <template slot-scope="scope">
            <n-button type="info" @click.native="edit(scope)">編輯權限</n-button>
          </template>
        </el-table-column>
      </data-tables>
    </div>
    <modal :show.sync="modals.classic" headerclasses="justify-content-center">
      <h4 slot="header" class="title title-up">編輯權限</h4>
      <template>
        <el-tag
          :key="tag"
          v-for="tag in disPlayAcls"
          size="small"
          type="primary"
          :closable="true"
          :close-transition="false"
          @close="handleClose(tag)"
        >{{tag}}</el-tag>
        <br>
        <el-select
          class="select-danger"
          placeholder="Single Select"
          v-model="selects.simple"
          @change="selChange"
        >
          <el-option
            v-for="option in caledSelects"
            class="select-danger"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </template>
      <template slot="footer">
        <n-button @click.native="modals.classic = false">取消</n-button>
        <n-button type="danger" @click.native="editConfirm">確定</n-button>
      </template>
    </modal>
        <n-button type="default" @click.native="back">返回</n-button>
  </card>
</template>

<script>
import { fetchManagers } from "src/javascripts/generalPages/fetchData";
import { Card, StatsCard } from "src/components";
import {
  Checkbox,
  Radio,
  Switch,
  FormGroupInput as FgInput
} from "src/components/index";
import { Modal } from "src/components";
import { Tag } from "element-ui";
import { Select, Option } from "element-ui";
import { editAcls } from "src/javascripts/generalPages/postData";
import swal from "sweetalert2";
var type = '';

export default {
  components: {
    Card,
    StatsCard,
    Checkbox,
    Radio,
    FgInput,
    [Switch.name]: Switch,
    Modal,
    [Tag.name]: Tag,
    [Select.name]: Select,
    [Option.name]: Option
  },
  beforeRouteEnter(to, from, next) {
    const  id = to.params.id;
    type = to.params.type;
    console.log('id', id, 'type', type)
    fetchManagers(type, id)
      .then(res => {
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        next(vm => vm.setData(res.data));
        console.log("err: ", err);
      });
  },
  data() {
    return {
      tableData: [
        // {
        //   name: "Pin Chen",
        //   phone: "+886987654321",
        //   acls: ["shop", "user"]
        // }
      ],
      filters: [
        {
          prop: ["accountId", "name"],
          value: ""
        }
      ],
      tableProps: {
        defaultSort: {
          prop: "accountId",
          order: "descending"
        }
      },
      modals: {
        classic: false
      },
      tags: {
        dynamicTags: ["Tag 1", "Tag 2", "Tag 3"],
        inputVisible: false,
        inputValue: ""
      },
      selects: {
        simple: "",
        languages: [
          { value: "Bahasa Indonesia", label: "Bahasa Indonesia" },
          { value: "Bahasa Melayu", label: "Bahasa Melayu" }
        ]
      },
      acls: ["shop", "product", "user", "contract", "admin", "report", "order"],
      disPlayAcls: [],
      dynamicSelects: [
        { value: "shop", label: "商店管理" },
        { value: "product", label: "商品管理" },
        { value: "user", label: "權限管理" },
        { value: "contract", label: "合約管理" },
        { value: "admin", label: "Admin" },
        { value: "report", label: "營業報表" },
        { value: "order", label: "訂單管理" },
        { value: "productoperator",label:"商品上下架"},
        { value: "subscribeoperator",label:"推播設定"},
        { value: "deliverySys",label:"物流拋單"}
      ],
      dynamicTags: ["shop"],
      caledTags: [],
      caledSelects: [],
      clickedUser: {}
    };
  },
  methods: {
    setData(data) {
      if(data.managers.length > 0) {
        data.managers.forEach((manager, index) => {
          let obj = Object.assign({}, { ...manager });
          this.$set(this.tableData, index, obj);
        });
      }
    },
    handleClose(tag) {
      this.disPlayAcls.splice(this.disPlayAcls.indexOf(tag), 1);
      this.reCalTags(this.disPlayAcls);
      this.caledSelects = this.calSelects(this.caledTags);
    },
    calTags(acls) {
      let aclArr = acls.map(acl => this.aclTranslator(acl));
      aclArr.forEach((acl, index) => {
        this.$set(this.disPlayAcls, index, acl);
      });
    },
    reCalTags(acls) {
      let aclArr = acls.map(acl => this.reAclTranslator(acl));
      this.caledTags.splice(0, this.caledTags.length);
      aclArr.forEach((acl, index) => {
        this.$set(this.caledTags, index, acl);
      });
    },
    calSelects(acls) {
      this.dynamicSelects.filter(option => {
        return true;
      });
      return this.dynamicSelects.filter(option => !acls.includes(option.value));
    },
    edit(scope) {
      let row = scope.row;
      this.modals.classic = true;
      let userAcls = row.acls;
      this.caledTags = userAcls;
      this.calTags(this.caledTags);
      this.caledSelects = this.calSelects(userAcls);
      this.clickedUser = row;
    },
    editConfirm() {
      let editAclsData = {
        userId: this.clickedUser.userId,
        acls: this.clickedUser.acls,
        accountId: this.clickedUser.accountId
      };
      editAcls(editAclsData, type)
        .then(res => {
          swal.fire("編輯權限成功").then(res => {
            this.modals.classic = false; // close modal
          });
        })
        .catch(err => {
          console.log("editAcls err: ", err.stack);
        });
    },
    selChange() {
      let newTag = this.selects.simple;
      this.caledTags.push(newTag);
      this.calTags(this.caledTags);
      this.caledSelects = this.calSelects(this.clickedUser.acls);
    },
    aclTranslator(acl) {
      switch (acl) {
        case 'admin':
          return "Admin"
          break;
        case 'order':
          return "訂單管理"
          break;
        case 'shop':
          return "商店管理"
          break;
        case 'product':
          return "商品管理"
          break;
        case 'user':
          return "權限管理"
          break;
        case 'report':
          return "營業報表"
          break;
        case 'contract':
          return "合約管理"
          break;
        case 'productoperator':
          return "商品上下架"
        case 'subscribeoperator':
          return "推播設定"
        case 'deliverySys':
          return "物流拋單"
        default:
          break;
      }
    },
    reAclTranslator(acl) {
      switch (acl) {
        case 'Admin':
          return "admin"
          break;
        case '訂單管理':
          return "order"
          break;
        case '商店管理':
          return "shop"
          break;
        case '商品管理':
          return "product"
          break;
        case '權限管理':
          return "user"
          break;
        case '營業報表':
          return "report"
          break;
        case '合約管理':
          return "contract"
          break;
        default:
          break;
      }
    },
    back() {
      window.history.back();
    }
  }
};
</script>